/**
 * This file contains HTTP request related constants like cookie names,
 * headers, etc.
 */

/* Cookies */
export const CSRF_COOKIE = '_js_csrf';

/* Headers */
export const CSRF_HEADER = 'X-CSRF-TOKEN';
